import { render } from "./VolumesOverlay.vue?vue&type=template&id=3fcd2c27&scoped=true&ts=true"
import script from "./VolumesOverlay.vue?vue&type=script&setup=true&lang=ts"
export * from "./VolumesOverlay.vue?vue&type=script&setup=true&lang=ts"

import "./VolumesOverlay.vue?vue&type=style&index=0&id=3fcd2c27&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fcd2c27"],['__file',"src/components/VolumesOverlay.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3fcd2c27"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3fcd2c27', __exports__)) {
    api.reload('3fcd2c27', __exports__)
  }
  
  module.hot.accept("./VolumesOverlay.vue?vue&type=template&id=3fcd2c27&scoped=true&ts=true", () => {
    api.rerender('3fcd2c27', render)
  })

}


export default __exports__